import type { Theme } from "../../schadenmeldung/theme";

/**
 * Refined-Theme (kvp-rd) für die Meldungsschritte innerhalb der Schadenmappe.
 * Werte aus `redesign/contactRedesign.css` (`.kvp-rd`): --aub, --aub-deep,
 * --gold, --gold-light, --ink, --line, --field. Seitenhintergrund bleibt
 * transparent, weil die Schritte in der Mappe (nicht auf einer eigenen Seite) stehen.
 */
export const refinedTheme: Theme = {
  name: "refined",
  primary: "#7d2169",
  primaryDeep: "#2c0a26",
  accent: "#f0a020",
  accentSoft: "#f3dcae",
  ink: "#241522",
  onDark: "#ffffff",
  onDarkMuted: "rgba(255,255,255,0.72)",
  pageBg: "transparent",
  pageGradient: "none",
  cardBg: "#ffffff",
  cardBorder: "#ece6ec",
  inputBg: "#ffffff",
};
